import {ApiRequest, RequestMethod} from "../../../request";

export async function deleteUpgrade(id: string): Promise<boolean> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.DELETE);
    apiRequest.setUrl(`/api/weapon-upgrade/${id}`);

    const response: any = await apiRequest.send();

    return response.status === 200;
}